import { render, staticRenderFns } from "./tuijianbb.vue?vue&type=template&id=7f4b329b&scoped=true&"
import script from "./tuijianbb.vue?vue&type=script&lang=js&"
export * from "./tuijianbb.vue?vue&type=script&lang=js&"
import style0 from "./tuijianbb.vue?vue&type=style&index=0&id=7f4b329b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b329b",
  null
  
)

export default component.exports